<template>
  <div id="app">
    <print-screen v-if="!isPhoneStyle"></print-screen>
    <keep-alive include="PersonCenter">
      <router-view v-if="isRouterAlive"></router-view>
    </keep-alive>
    <login-popup v-if="goLogin == 'login'"></login-popup>
    <register v-else-if="goLogin == 'register'"></register>
    <replace-password v-else-if="goLogin == 'replace'"></replace-password>
    <i class="iconfont icon-huidaodingbu" v-show="isShowTop" @click="backTop"></i>
  </div>
</template>

<script>
import Utils from "@/assets/js/Utils";
import { setupWebSocket } from '@/assets/js/websocket';
import common from "@/assets/js/common";
import LoginPopup from './components/common/LoginPopup.vue';
import Register from './components/account/Register.vue';
import ReplacePassword from './components/account/ReplacePassword.vue';
import { QueryAppDetail } from '@/api/common/common';
import { webLogin, isBackOrStage } from '@/utils/login';
import SelfSelect from './components/common/SelfSelect.vue';
import PrintScreen from './components/common/PrintScreen.vue';
import router from "./router";
export default {
  name: 'app',
  components: { LoginPopup, Register, ReplacePassword, SelfSelect, PrintScreen },
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      /**是否显示回到顶部图标 */
      isShowTop: false,
    }
  },
  computed: {
    isBigMode() {
      return this.$store.state.menu.isBigMode;
    },
    /**是否为后台系统 */
    isMag() {
      return this.$store.state.manage.isMag;
    },
    goLogin() {
      return this.$store.state.menu.goLogin;
    },
    /**刷新标识 */
    isRouterAlive() {
      return this.$store.state.home.isRouterAlive;
    },
    /**是否展示手机风格 */
    isPhoneStyle() {
      return this.$store.state.media.isPhoneStyle;
    }
  },
  async mounted() {
    this.$router.onReady(()=>{
      this.reponseLayout();
    })
    this.handUrlParams();
    this.monitorScroll();
    Utils.$on('user-login', this.emitEvent);
    Utils.$on('account_token_update', this.offLine);
    let token = common.getCookie("token");
    if (token) {
      this.emitEvent();
      this.queryAppDetail();
      let userId=common.getCookie("userId");
      this.$store.commit('saveInfo');
      token&&sessionStorage.setItem('token', token);
      userId&&sessionStorage.setItem('userId', userId);
    }
    webLogin();
  },
  beforeDestroy() {
    var ws = this.$store.state.user.socketTimer.ws;
    this.$store.commit('clearTimer');
    this.$store.commit('changeSocket', { label: 'connect', value: false });
    ws && ws.close();
  },
  destroyed() {
    // 在组件销毁时解绑事件监听
    Utils.$off('user-login', this.emitEvent);
    this.$store.commit('changeCurrentNav', '');
  },
  methods: {
    reponseLayout(){
      if(this.$route.meta.classify == 'manage'){
        let xml=document.getElementsByTagName('html')[0];
        if(xml){
          xml.style.fontSize='10px';
        }
        return;
      };
      window.addEventListener('resize', this.setFontSize);
      this.setFontSize();
    },
    setupHeartbeatTimer(callback) {
      if (!this.$store.getters.getToken) return;
      setupWebSocket(callback);
    },
    /**顶人下线提示 */
    offLine(e) {
      this.$msg({
        showClose: true,
        message: e.msg,
        type: "error",
      });
      isBackOrStage();
    },
    /**获取应用详情 */
    queryAppDetail() {
      QueryAppDetail({ id: process.env.VUE_APP_APP_CODE }).then(res => {
        if (res.code == 200) {
          this.$store.commit('changeAppInfo', res.data);
        }
      })
    },
    /**修改系统标题 */
    changeSysTitle() {
      var dom = document.querySelector('.sys-title');
      var collegeId = sessionStorage.getItem('institutionTenantId');
      var collegeName = sessionStorage.getItem('collegeName');
      var index = window.location.href.indexOf('/magSys');
      if (collegeId) {
        dom.innerHTML = collegeName;
      } else if (index != -1) {
        dom.innerHTML = '后台管理系统';
      } else {
        dom.innerHTML = '虚拟仿真平台';
      }
    },
    /**获取url中的参数 */
    handUrlParams() {
      let url = location.href;
      let str = url.split("?")[1];
      if (str) {
        let arr = str.split('&');
        arr.forEach(item => {
          var arr1 = item.split('=');
          sessionStorage.setItem(arr1[0], decodeURIComponent(arr1[1]));
        })
      }
      this.$nextTick(() => {
        var nav = this.$refs.nav;
        nav && nav.isCollege();
      })
    },
    setPadding(padding) {
      document.documentElement.style.setProperty('--padding', padding);
    },
    /**动态设置fontSize实现响应式 */
    setFontSize() {
      var width = window.innerWidth;
      var html = document.getElementsByTagName('html')[0];
        this.$store.commit('media/changePhoneStyle', width);
        if (width < 1500) {
          if (width > 750) {
            this.setPadding('10rem');
          } else {
            html.style.setProperty('--bigTitle',48*width/750+'px');
            html.style.setProperty('--smallTitle',28*width/750+'px');
            this.setPadding('2rem');
          }
          width = 1500;
        } else {
          this.setPadding(`30rem`);
        }
      var rate = 10 / 1920;
      if (html) {
        html.style.fontSize = width * rate + 'px';
        this.$store.commit('common/changeFontSize', width * rate);
      }
    },
    /**监听滚动高度 */
    monitorScroll() {
      var dom = document.querySelector('#app');
      dom && dom.addEventListener('scroll', (e) => {
        if (dom.scrollTop > 200) {
          this.isShowTop = true;
        } else {
          this.isShowTop = false;
        }
      })
    },
    /**回到顶部 */
    backTop() {
      var dom = document.querySelector('#app');
      dom && dom.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // 可选，平滑滚动效果
      });
    },
    emitEvent() {
      this.setupHeartbeatTimer();
    },
    reload() {
      this.$store.commit('home/changeRouteAlive', false);
      this.$nextTick(function () {
        this.$store.commit('home/changeRouteAlive', true);
      })
    }
  },
  watch: {
    $route: {
      handler() {
        this.changeSysTitle();
      }, immediate: true
    },
  },
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
  font-size: 14px;
  white-space: nowrap;
  position: relative;
  height: 100%;
  overflow-y: scroll;
}

.icon-huidaodingbu {
  position: fixed;
  right: 5rem;
  bottom: 5rem;
  font-size: 4rem;
  color: rgba(204, 204, 204, .8);
  cursor: pointer;
  z-index: 998;
}
</style>
